const initModal = () => {
  const autoCloseTimers = new WeakMap()

  const clearAutoClose = (modal) => {
    const timer = autoCloseTimers.get(modal)
    if (timer) {
      clearTimeout(timer)
      autoCloseTimers.delete(modal)
    }
  }

  const showModal = (modal) => {
    // Remove any pending closing state first
    modal.classList.remove('modal--closing')

    // Make modal visible before starting animation
    modal.classList.remove('hidden')
    requestAnimationFrame(() => {
      modal.classList.add('modal--open')
      document.body.classList.add('overflow-hidden') // Prevent background scrolling
    })

    // Auto-focus first visible input
    const firstInput = modal.querySelector(
      'input:not([type="hidden"]):not([disabled]), textarea:not([disabled])'
    )
    if (firstInput) {
      setTimeout(() => firstInput.focus(), 120)
    }

    // Close by itself after the lifetime the modal declares (in milliseconds)
    const autoCloseDelay = parseInt(modal.dataset.autoClose, 10)
    if (autoCloseDelay > 0) {
      clearAutoClose(modal)
      autoCloseTimers.set(
        modal,
        setTimeout(() => hideModal(modal), autoCloseDelay)
      )
    }
  }

  const hideModal = (modal) => {
    clearAutoClose(modal)
    modal.classList.remove('modal--open')
    modal.classList.add('modal--closing')

    // Wait for transition to finish before fully hiding
    const timeout = setTimeout(() => {
      modal.classList.add('hidden')
      modal.classList.remove('modal--closing')
    }, 220)

    // Ensure scroll is restored even if transition is interrupted
    modal.addEventListener(
      'transitionend',
      () => {
        clearTimeout(timeout)
        modal.classList.add('hidden')
        modal.classList.remove('modal--closing')
        document.body.classList.remove('overflow-hidden')
      },
      { once: true }
    )

    // Fallback restore for browsers that might not fire transitionend
    setTimeout(() => document.body.classList.remove('overflow-hidden'), 230)
  }

  // Open modal
  document.querySelectorAll('[data-modal-target]').forEach((card) => {
    card.addEventListener('click', () => {
      const modalId = card.getAttribute('data-modal-target')
      const modal = document.querySelector(`[data-modal-id="${modalId}"]`)
      if (modal) showModal(modal)
    })
  })

  // Close modal via close button or backdrop
  document.querySelectorAll('[data-modal-close]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation()
      const modalId = btn.getAttribute('data-modal-close')
      const modal = document.querySelector(`[data-modal-id="${modalId}"]`)
      if (modal) hideModal(modal)
    })
  })

  // Close modal when clicking on backdrop
  document.querySelectorAll('[data-modal-id]').forEach((modal) => {
    modal.addEventListener('click', (e) => {
      if (e.target === modal) hideModal(modal)
    })
  })

  // Auto-open any modal flagged for load (e.g., flash modal)
  document
    .querySelectorAll('[data-modal-id][data-auto-open="true"]')
    .forEach((modal) => showModal(modal))
}

export default initModal
